<template xmlns:v-bind="http://www.w3.org/1999/xhtml">

  <div id="gallery2020" style="margin-top: 3rem;">

      <div style="margin-bottom: 5rem;">
          <b-img alt="Großer Kartelltag" src="/public/downloads/directories/images/corona.jpg" fluid />
      </div>

      <h2 style="margin-top: 2rem;">Sommer- und Wintersemster 2020</h2>
      <br/>
      <div v-for="(folder, index) in pictureFolders" :key="index">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block href="#" v-b-toggle="'accordion-' + index" variant="warning">{{folder.description}}</b-button>
            </b-card-header>
            <b-collapse v-bind:id="'accordion-' + index" accordion="picture-accordion" role="tabpanel">
              <b-card-body>
                    <b-carousel
                        id="carousel-no-anim"
                        style="text-shadow: 0px 0px 2px #000"
                        no-animation
                        :interval="10000"
                        controls
                    >
                        <div v-for="picture in folder.pictures">
                            <b-carousel-slide v-bind:img-src="picture.fileDownloadUri"/>
                        </div>
                    </b-carousel>
              </b-card-body>
            </b-collapse>
          </b-card>
      </div>
  </div>

</template>

<script>

    import {PICTURE_REQUEST} from '@/store/actions/pictures'

    export default {
      name: 'pictures',
      mounted () {
        console.log('Start first request');
        this.$store.dispatch(PICTURE_REQUEST, 2020);
      },
      computed: {
        pictureFolders: function() {
          console.log("Try to show pictures");
          return this.$store.getters.getPictures
        }
      },
    }

</script>